module.exports = __webpack_public_path__ + "img/Polycom_600.a3bb6213.png";